<template>
  <vue-simple-table
    class="table"
    small-padding
    head-background
    bordered
    :hoverable-rows="false"
  >
    <template #colgroup>
      <col :width="`${100 - metricColWidth * columns.length}%`">
      <col
        v-for="_ of columns"
        :width="`${metricColWidth}%`"
      >
    </template>
    <template #head>
      <vue-line type="head">
        <vue-item>Тип страниц</vue-item>
        <vue-item
          v-for="(channel, i) of columns"
          :key="i"
        >
          {{ channel }}
        </vue-item>
        <vue-item>Итого</vue-item>
      </vue-line>
    </template>
    <template #body>
      <vue-line
        v-for="(item, i) of items"
        :key="i"
        :class="{summary: typeof item.id === 'string' && item.id.includes('sum')}"
      >
        <vue-item>{{ item.name }}</vue-item>
        <vue-item
          v-for="(channel, i) of columns"
          :key="i + channel"
          align="right"
        >
          <div class="metric">
            <div class="metric__value">
              {{ getValue(item.channels, channel) | formatCount }}
            </div>

            <vue-element
              v-if="item.channels[channel] && (item.channels[channel][`${metric.id}_diff`] || item.channels[channel][`${metric.id}_diff`] === 0)"
              class="metric__diff"
              type="label"
              :data="getDiff(item.channels[channel], channel)"
              :locale-options="{maximumFractionDigits: 0}"
              temperature
              label-note="%"
            />
          </div>
        </vue-item>
        <vue-item align="right">
          <div class="metric">
            <div class="metric__value">
              {{
                (item[`${metric.id}_one`] || item[`${metric.id}_one`] === 0 ? item[`${metric.id}_one`] : '-') | formatCount
              }}
            </div>

            <vue-element
              v-if="item[`${metric.id}_diff`] || item[`${metric.id}_diff`] === 0"
              class="metric__diff"
              type="label"
              :data="getDiff(item)"
              :locale-options="{maximumFractionDigits: 0}"
              temperature
              label-note="%"
            />
          </div>
        </vue-item>
      </vue-line>
    </template>
  </vue-simple-table>
</template>

<script>
import {roundNumber} from '@/function'

export default {
  name: 'tableEntityChannelsDiff',

  props: {
    items: {
      type: Array,
      default: () => ([])
    },

    metric: {
      type: Object,
      default: () => ({})
    },

    columns: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      metricColWidth: 15
    }
  },

  methods: {
    roundNumber,

    getValue(data, channel) {
      return data && data[channel] && (data[channel][`${this.metric.id}_one`] || data[channel][`${this.metric.id}_one`] === 0)
        ? data[channel][`${this.metric.id}_one`]
        : '-'
    },

    getDiff(data) {
      if (data) {
        const one = data[`${this.metric.id}_one`]
        const two = data[`${this.metric.id}_two`]
        const diff = data[`${this.metric.id}_diff`]

        return diff === undefined
          ? undefined
          : diff === 0
            ? 0
            : diff === one
              ? 100
              : roundNumber((diff * 100 / two), 0)
      } else {
        return undefined
      }
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  & /deep/ thead .table-item {
    background: linear-gradient(0deg, rgba(255, 255, 255, .9), rgba(255, 255, 255, .9)), #C2C9D1 !important;
    color: #455165;
  }
}

.metric {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 4px;

  &__diff._bg {
    height: 16px;
    padding: 0 4px;
    line-height: 16px;
    font-size: 12px;
  }
}

.summary {
  font-weight: 500;
}
</style>
